const CLIENT_INFOS = [
  {
    customerName: 'REX WORK . SAFETY B',
    enterpriseCode: 'REXW',
    slug: 'REXW',
    libelleString: 'REX WORK . SAFETY B',
  },
  {
    customerName: 'ETRIS BANK GMB',
    enterpriseCode: 'EDEB',
    slug: 'EDEB',
    libelleString: 'ETRIS BANK GMB',
  },
  {
    customerName: 'REBEL SAFETYGEAR (PTY) LTD /R',
    enterpriseCode: 'RBEL',
    slug: 'RBEL',
    libelleString: 'REBEL SAFETYGEAR (PTY) LTD /R',
  },
  {
    customerName: 'MARKKINOINTI MUIKKU OY ',
    enterpriseCode: 'MUIK',
    slug: 'MUIK',
    libelleString: 'MARKKINOINTI MUIKKU OY ',
  },
  {
    customerName: 'ARGENSOL PEINTURES VIREMENT DE',
    enterpriseCode: 'ARPE',
    slug: 'ARPE',
    libelleString: 'ARGENSOL PEINTURES VIREMENT DE',
  },
  {
    "customerName": "PCH Technischer Handel",
    "enterpriseCode": "PCHP",
    "slug": "PCHP",
    "libelleString": "PCH Technischer Handel",
  },
  {
    "customerName": "ETRIS BANK GMBH",
    "enterpriseCode": "EDEB",
    "slug": "EDEB",
    "libelleString": "EDEB-",
  },
  {
    "customerName": "  WORK . SPORT BELGIUM BV",
    "enterpriseCode": "WSBE",
    "slug": "WSBE",
    "libelleString": "WSBE-",
  },
  {
    "customerName": "WIP SRL",
    "enterpriseCode": "WIPS",
    "slug": "WIPS",
    "libelleString": "W.I.P. SRL INVOICE",
  },
  {
    "customerName": "BVS PROTOOLS B.V.",
    "enterpriseCode": "BVSP",
    "slug": "BVSP",
    "libelleString": "BVSP-",
  },
  {
    "customerName": "Prosafco",
    "enterpriseCode": "PROS",
    "slug": "PROS",
    "libelleString": "PROSAFCO NV",
  },
  {
    "customerName": "GAMMA PENNELLI",
    "enterpriseCode": "GAPE",
    "slug": "GAPE",
    "libelleString": "GAMMA PENNELLI",
  },
  {
    "customerName": "HESKO",
    "enterpriseCode": "HESK",
    "slug": "HESK",
    "libelleString": "HESKO ARBEITSSCHUTZ",
  },
  {
    "customerName": "BOGMAR",
    "enterpriseCode": "BOGM",
    "slug": "BOGM",
    "libelleString": " BOGMAR BB SPOLKA Z OGRAN",
  },
  {
    "customerName": "Trital Safety",
    "enterpriseCode": "TRSA",
    "slug": "TRSA",
    "libelleString": "TRITAL SAFETY B.V. BETALINGSKENM.",
  },
  {
    "customerName": "Groupe RG (France)",
    "enterpriseCode": "RGFR",
    "slug": "RGFR",
    "libelleString": "RG FRANCE ",
  },
  {
    "customerName": "VOS TOOLS",
    "enterpriseCode": "VOST",
    "slug": "VOST",
    "libelleString": " VOS TOOLS ",
  },
  {
    "customerName": "VOS TOOLS",
    "enterpriseCode": "VOST",
    "slug": "VOST",
    "libelleString": " VOS POORTEN",
  },
  {
    "customerName": "De Stalen Greep",
    "enterpriseCode": "STGR",
    "slug": "STGR",
    "libelleString": "DE STALEN GREEP",
  },
  {
    "customerName": "MABEO",
    "enterpriseCode": "MABE",
    "slug": "MABE",
    "libelleString": "MABEO INDUSTRIES",
  },
  {
    "customerName": "G. Elsinghorst",
    "enterpriseCode": "ELSI",
    "slug": "ELSI",
    "libelleString": "G. Elsinghorst",
  },
  {
    "customerName": "Partner",
    "enterpriseCode": "PART",
    "slug": "PART",
    "libelleString": "Partner",
  },
  {
    "customerName": "Lyreco Switzerland AG",
    "enterpriseCode": "LYRS",
    "slug": "LYRS",
    "libelleString": "Lyreco Switzerland AG",
  },
  {
    "customerName": "GRUBE",
    "enterpriseCode": "GRUB",
    "slug": "GRUB",
    "libelleString": "GRUBE KG FORSTGERAETESTE",
  },
  {
    "customerName": "Work & Sport Belgium",
    "enterpriseCode": "WSBE",
    "slug": "WSBE",
    "libelleString": "Work & Sport Belgium",
  },
  {
    "customerName": "myprotection",
    "enterpriseCode": "MYPR",
    "slug": "MYPR",
    "libelleString": "MY-PROTECTION",
  },
  {
    "customerName": "INKA",
    "enterpriseCode": "INKA",
    "slug": "INKA",
    "libelleString": "INKA BV ",
  },
  {
    "customerName": "ASSI Teclog AG Germany",
    "enterpriseCode": "ASSI",
    "slug": "ASSI",
    "libelleString": "ASSI TECLOG",
  },
  {
    "customerName": "NOW NETHERLANDS",
    "enterpriseCode": "DNOW",
    "slug": "DNOW",
    "libelleString": "NOW NETHERLANDS",
  },
  {
    "customerName": "Juba",
    "enterpriseCode": "JUBA",
    "slug": "JUBA",
    "libelleString": "Juba",
  },
  {
    "customerName": "Global Safety(VANDEPUTTE)",
    "enterpriseCode": "VPUT",
    "slug": "VPUT",
    "libelleString": "GLOBAL SAFETY",
  },
  {
    "customerName": "TIBAS",
    "enterpriseCode": "TIBA",
    "slug": "TIBA",
    "libelleString": "TIBAS",
  },
  {
    "customerName": "ASTA GmbH & Co. KG",
    "enterpriseCode": "ASTA",
    "slug": "ASTA",
    "libelleString": "ASTA GmbH & Co. KG",
  },
  {
    "customerName": "DEXIS Belgium",
    "enterpriseCode": "DEXI",
    "slug": "DEXI",
    "libelleString": "DEXIS BELGIUM NV",
  },
  {
    "customerName": "Condor Safety",
    "enterpriseCode": "COSA",
    "slug": "COSA",
    "libelleString": "Condor Safety",
  },
  {
    "customerName": "MEWA",
    "enterpriseCode": "MEWA",
    "slug": "MEWA",
    "libelleString": "MEWA",
  },
  {
    "customerName": "Dietel Arbeitsschutz",
    "enterpriseCode": "DIET",
    "slug": "DIET",
    "libelleString": "Dietel Arbeitsschutz",
  },
  {
    "customerName": "LISAP",
    "enterpriseCode": "LISA",
    "slug": "LISA",
    "libelleString": "ISABEL LISA",
  },
  {
    "customerName": "LISAP",
    "enterpriseCode": "LISA",
    "slug": "LISA",
    "libelleString": "LISAP SA",
  },
  {
    "customerName": "Reuschenbach Handels-u. Fertigungs",
    "enterpriseCode": "REUS",
    "slug": "REUS",
    "libelleString": "Reuschenbach Handels-u. Fertigungs",
  },
  {
    "customerName": "DRAEBERGS",
    "enterpriseCode": "DRAE",
    "slug": "DRAE",
    "libelleString": "DRAEBERGS",
  },
  {
    "customerName": "Peeters-Lambrechts Safety",
    "enterpriseCode": "PEET",
    "slug": "PEET",
    "libelleString": "BV PEETERS",
  },
  {
    "customerName": "RG Arbeitsschutz",
    "enterpriseCode": "RGDE",
    "slug": "RGDE",
    "libelleString": "RG ARBEITSSCHUTZ GMBH",
  },
  {
    "customerName": "Arthur Weber AG",
    "enterpriseCode": "FURT",
    "slug": "ARWE",
    "libelleString": "ARTHUR WEBER",
  },
  {
    "customerName": "Arthur Weber AG",
    "enterpriseCode": "ARWE",
    "slug": "ARWE",
    "libelleString": "ARTHUR WEBER",
  },
  {
    "customerName": "Delcaert",
    "enterpriseCode": "DELC",
    "slug": "DELC",
    "libelleString": "Delcaert",
  },
  {
    "customerName": "Hygiene Partner",
    "enterpriseCode": "HYPA",
    "slug": "HYPA",
    "libelleString": " BRILLIANT GROUP BV ",
  },
  {
    "customerName": "GEMA GROUP",
    "enterpriseCode": "GEMA",
    "slug": "GEMA",
    "libelleString": "GEMA GROUP",
  },
  {
    "customerName": "BGS Safety Product",
    "enterpriseCode": "BGSS",
    "slug": "BGSS",
    "libelleString": "BGS Safety Product",
  },
  {
    "customerName": "Schröter",
    "enterpriseCode": "SCHR",
    "slug": "SCHR",
    "libelleString": "Schröter",
  },
  {
    "customerName": "Foussier",
    "enterpriseCode": "FOUS",
    "slug": "FOUS",
    "libelleString": "FOUSSIER VIREMENT FOUSSIER",
  },
  {
    "customerName": "DOSCO",
    "enterpriseCode": "DOSC",
    "slug": "DOSC",
    "libelleString": "DOSCO",
  },
  {
    "customerName": "Mastersafe",
    "enterpriseCode": "MAST",
    "slug": "MAST",
    "libelleString": "Master Safe SRL",
  },
  {
    "customerName": "De Nieuwe Gouden Spade NV",
    "enterpriseCode": "DNGS",
    "slug": "DNGS",
    "libelleString": "De Nieuwe Gouden Spade NV",
  },
  {
    "customerName": "Lyreco Switzerland AG",
    "enterpriseCode": "LYRS",
    "slug": "LYRS",
    "libelleString": "LYRS-",
  },
  {
    "customerName": "KONSTANT",
    "enterpriseCode": "KONS",
    "slug": "KONS",
    "libelleString": "KONSTANT",
  },
  {
    "customerName": "Robert De Vries",
    "enterpriseCode": "ROBE",
    "slug": "ROBE",
    "libelleString": "ROBERT DE VRIES",
  },
  {
    "customerName": "BAUDI",
    "enterpriseCode": "BAUD",
    "slug": "BAUD",
    "libelleString": "BAUDI GMBH",
  },
  {
    "customerName": "Distrilab Industrie",
    "enterpriseCode": "DIST",
    "slug": "DIST",
    "libelleString": "Distrilab Industrie",
  },
  {
    "customerName": "Tereva",
    "enterpriseCode": "TERE",
    "slug": "TERE",
    "libelleString": "TEREVA TEREVA ",
  },
  {
    "customerName": "Wonder Grip EMEA markets",
    "enterpriseCode": "WGFR",
    "slug": "WGFR",
    "libelleString": "Wonder Grip EMEA markets",
  },
  {
    "customerName": "TIBAS",
    "enterpriseCode": "TIBA",
    "slug": "TIBA",
    "libelleString": "TIBAS GUMMI GMBH",
  },
  {
    "customerName": "QIB",
    "enterpriseCode": "QIBV",
    "slug": "QIBV",
    "libelleString": "QIB",
  },
  {
    "customerName": "REX Work&Safety BV",
    "enterpriseCode": "REXW",
    "slug": "REXW",
    "libelleString": "REX Work&Safety BV",
  },
  {
    "customerName": "BRADO",
    "enterpriseCode": "BRAD",
    "slug": "BRAD",
    "libelleString": "BRADO",
  },
  {
    "customerName": "INKA",
    "enterpriseCode": "INKA",
    "slug": "INKA",
    "libelleString": "INKA BV",
  },
  {
    "customerName": "DHL Supply Chain (Leipzig) GmbH",
    "enterpriseCode": "DHLS",
    "slug": "DHLS",
    "libelleString": "DHL Supply Chain (Leipzig) GmbH",
  },
  {
    "customerName": "IWS Isar Werkzeug- und Schraubenhandels GmbH",
    "enterpriseCode": "ISAR",
    "slug": "ISAR",
    "libelleString": "IWS Isar Werkzeug- und Schraubenhandels GmbH",
  },
  {
    "customerName": "Gibb Group B.V. ",
    "enterpriseCode": "GIBV",
    "slug": "GIBV",
    "libelleString": "GIBB GROUP NETHERLANDS",
  },
  {
    "customerName": "Guardtech Hungary",
    "enterpriseCode": "GUAR",
    "slug": "GUAR",
    "libelleString": "Guardtech Hungary",
  },
  {
    "customerName": "Adalbert Zajadacz",
    "enterpriseCode": "ZAJA",
    "slug": "ZAJA",
    "libelleString": "ADALBERT ZAJADACZ",
  },
  {
    "customerName": "Willi POHL",
    "enterpriseCode": "POHL",
    "slug": "POHL",
    "libelleString": "Willi POHL",
  },
  {
    "customerName": "Vancanneyt",
    "enterpriseCode": "VANC",
    "slug": "VANC",
    "libelleString": "Vancanneyt",
  },
  {
    "customerName": "Juba",
    "enterpriseCode": "JUBA",
    "slug": "JUBA",
    "libelleString": "JUBA PERSONAL PROTECTIVE",
  },
  {
    "customerName": "Craft eCom",
    "enterpriseCode": "CREC",
    "slug": "CREC",
    "libelleString": "CRAFT ECOM GMBH",
  },
  {
    "customerName": "Pflanzen Peikert",
    "enterpriseCode": "PFLP",
    "slug": "PFLP",
    "libelleString": "Pflanzen Peikert",
  },
  {
    "customerName": "Donckers",
    "enterpriseCode": "DONC",
    "slug": "DONC",
    "libelleString": "DONCKERS GEREEDSCHAPPEN",
  },
  {
    "customerName": "Partner",
    "enterpriseCode": "PART",
    "slug": "PART",
    "libelleString": "PARTNER BV",
  },
  {
    "customerName": "I.S. Varian & Company",
    "enterpriseCode": "ISVC",
    "slug": "ISVC",
    "libelleString": "I.S. Varian & Company",
  },
  {
    "customerName": "ASTA GmbH & Co. KG",
    "enterpriseCode": "ASTA",
    "slug": "ASTA",
    "libelleString": "ASTA GMBH",
  },
  {
    "customerName": "Mayer Baumarkt Ruhpolding",
    "enterpriseCode": "MBGM",
    "slug": "MBGM",
    "libelleString": "Mayer Baumarkt Ruhpolding",
  },
  {
    "customerName": "Wonder Grip UK markets",
    "enterpriseCode": "WGUK",
    "slug": "WGUK",
    "libelleString": "Wonder Grip UK markets",
  },
  {
    "customerName": "EuroProduction",
    "enterpriseCode": "EUPR",
    "slug": "EUPR",
    "libelleString": "EuroProduction",
  },
  {
    "customerName": "TB Immoservice GmbH",
    "enterpriseCode": "TBIS",
    "slug": "TBIS",
    "libelleString": "TB IMMOSERVICE GMBH",
  },
  {
    "customerName": "CROSA SRL",
    "enterpriseCode": "CORS",
    "slug": "CORS",
    "libelleString": "CROSA SRL",
  },
  {
    "customerName": "BHP Nawigator Uslugi",
    "enterpriseCode": "BHPN",
    "slug": "BHPN",
    "libelleString": "BHP Nawigator Uslugi",
  },
  {
    "customerName": "Tisza 97 KFT",
    "enterpriseCode": "TISZ",
    "slug": "TISZ",
    "libelleString": "Tisza 97 KFT",
  },
  {
    "customerName": "HVV BV",
    "enterpriseCode": "HVVB",
    "slug": "HVVB",
    "libelleString": "HANDELSONDERNEMING",
  },
  {
    "customerName": "WORKWEAR KRABBE GMBH",
    "enterpriseCode": "WWKG",
    "slug": "WWKG",
    "libelleString": "WWKG-",
  },
  {
    "customerName": "SCHW",
    "enterpriseCode": "SCHW",
    "slug": "SCHW",
    "libelleString": "SCHW-",
  },
  {
    "customerName": "Uzin Utz Tools GmbH",
    "enterpriseCode": "UUTG",
    "slug": "UUTG",
    "libelleString": "Uzin Utz Tools GmbH",
  },
  {
    "customerName": "RG Arbeitsschutz",
    "enterpriseCode": "RGDE",
    "slug": "RGDE",
    "libelleString": "RG ARBEITSSCHUTZ GMBH",
  },
  {
    "customerName": "Multipro D.O.O",
    "enterpriseCode": "MULT",
    "slug": "MULT",
    "libelleString": "Multipro D.O.O",
  },
  {
    "customerName": "Sahlberg GmbH",
    "enterpriseCode": "SAHL",
    "slug": "SAHL",
    "libelleString": "SAHLBERG GMBH",
  },
  {
    "customerName": "SK Workwear",
    "enterpriseCode": "SKWW",
    "slug": "SKWW",
    "libelleString": "SK Workwear",
  },
  {
    "customerName": "MDP Group",
    "enterpriseCode": "MDPG",
    "slug": "MDPG",
    "libelleString": "MDP GROUP NV",
  },
  {
    "customerName": "dft Logistik",
    "enterpriseCode": "DFTL",
    "slug": "DFTL",
    "libelleString": "dft Logistik",
  },
  {
    "customerName": "HAESKO BV",
    "enterpriseCode": "HAKO",
    "slug": "HAKO",
    "libelleString": "HAESKO BV",
  },


  {
    "customerName": "KEMI",
    "enterpriseCode": "KEMI",
    "slug": "KEMI",
    "libelleString": "KEMI",
  },
  {
    "customerName": "Gibb Group B.V. ",
    "enterpriseCode": "GIBV",
    "slug": "GIBV",
    "libelleString": "GIBB GROUP NETHERLANDS BV",
  },
  {
    "customerName": "DELCAERT",
    "enterpriseCode": "DELC",
    "slug": "DELC",
    "libelleString": "DELCAERT NV",
  },
  {
    "customerName": "Prolians (Descaud)",
    "enterpriseCode": "PRSC",
    "slug": "PRSC",
    "libelleString": "Prolians (Descaud)",
  },
  {
    "customerName": "Prolians Logistique",
    "enterpriseCode": "PRLI",
    "slug": "PRLI",
    "libelleString": "PROLIANS LOGISTIQUE CENT",
  },
  {
    "customerName": "Lyreco France",
    "enterpriseCode": "LYRF",
    "slug": "LYRF",
    "libelleString": "Lyreco France",
  },
  {
    "customerName": "Outilmat",
    "enterpriseCode": "OUMA",
    "slug": "OUMA",
    "libelleString": "Outilmat",
  },
  {
    "customerName": "A.Kreitz & W.H. Ostermann GmbH",
    "enterpriseCode": "KREI",
    "slug": "KREI",
    "libelleString": "A.Kreitz & W.H. Ostermann GmbH",
  },
  {
    "customerName": "HGC Commerciale",
    "enterpriseCode": "HGCC",
    "slug": "HGCC",
    "libelleString": "HGC Commerciale",
  },
  {
    "customerName": "Workcess Arbeitsschutz",
    "enterpriseCode": "WCAT",
    "slug": "WCAT",
    "libelleString": "WORKCESS ARBEITSSCHUTZ",
  },
  {
    "customerName": "Wilhelm Cramer",
    "enterpriseCode": "EDKC",
    "slug": "EDKC",
    "libelleString": "Wilhelm Cramer",
  },
  {
    "customerName": "RS COMPONENTS SAS",
    "enterpriseCode": "RSCO",
    "slug": "RSCO",
    "libelleString": "RS COMPONENTS SAS",
  },
  {
    "customerName": "M&S GmbH",
    "enterpriseCode": "MSGM",
    "slug": "MSGM",
    "libelleString": "M + S GMBH",
  },
  {
    "customerName": "Tomy GmbH",
    "enterpriseCode": "TOMG",
    "slug": "TOMG",
    "libelleString": "Tomy GmbH",
  },
  {
    "customerName": "flaschenpost SE",
    "enterpriseCode": "FLAS",
    "slug": "FLAS",
    "libelleString": "flaschenpost SE",
  },


  {
    "customerName": "RS COMPONENTS SAS",
    "enterpriseCode": "RSFR",
    "slug": "RSFR",
    "libelleString": "RS COMPONENTS SAS",
  },

  {
    "customerName": "BAUDI",
    "enterpriseCode": "BAUS",
    "slug": "BAUS",
    "libelleString": "BAUDI SUED GMBH ",
  },
  {
    "customerName": "KH VINNUFOT",
    "enterpriseCode": "KHVI",
    "slug": "KHVI",
    "libelleString": "KH VINNUFOT",
  },
  {
    "customerName": "Vosschemie Uetersen",
    "enterpriseCode": "VOSS",
    "slug": "VOSS",
    "libelleString": "Vosschemie Uetersen",
  },
  {
    "customerName": "ECSA Maintenance AG",
    "enterpriseCode": "ECSA",
    "slug": "ECSA",
    "libelleString": "ECSA Maintenance AG",
  },
  {
    "customerName": "All2work",
    "enterpriseCode": "ALLW",
    "slug": "ALLW",
    "libelleString": "All2work",
  },
  {
    "customerName": "Haberkorn GmbH",
    "enterpriseCode": "HABE",
    "slug": "HABE",
    "libelleString": "Haberkorn GmbH",
  },
  {
    "customerName": "Gibb Group B.V. ",
    "enterpriseCode": "GIBV",
    "slug": "GIBV",
    "libelleString": "Gibb Group B.V. ",
  },

  {
    "customerName": "EDE - buying group",
    "enterpriseCode": "EDEB",
    "slug": "EDEB",
    "libelleString": "EDE - buying group",
  },
  {
    "customerName": "manzpartner AG",
    "enterpriseCode": "MANZ",
    "slug": "MANZ",
    "libelleString": "manzpartner AG",
  },
  {
    "customerName": "Flaschenpost SE",
    "enterpriseCode": "FLAS",
    "slug": "FLAS",
    "libelleString": "Flaschenpost SE",
  },
  {
    "customerName": "Rubix France",
    "enterpriseCode": "RUFR",
    "slug": "RUFR",
    "libelleString": "Rubix France",
  },
  {
    "customerName": "DIE BAUMHELDEN",
    "enterpriseCode": "DBHA",
    "slug": "DBHA",
    "libelleString": "DBHA-",
  },
]

export default CLIENT_INFOS
